import React from 'react';
//import ConstantObject from '../Components/Constants';

import '../Styles/Social.css'

export default class  ImageList extends React.Component {

  constructor(props) {
    super(props);
    console.log("imagelist ....");
    //debugger;

    this.mountStyle = this.mountStyle.bind(this)
    this.unMountStyle = this.unMountStyle.bind(this)
    this.state ={ //base css
      show: true,
      style :{
        fontSize: 60,
        opacity: 0,
        transition: 'all 2s ease',
      }
    }
  }

  handleClick(p) {
    //e.preventDefault();
//    debugger;
    setTimeout(this.mountStyle, 10) // call the into animation
    setTimeout(this.props.SetBachan(p), 500)
  }

  componentWillReceiveProps(newProps) { // check for the mounted props
    if(!newProps.mounted)
      return this.unMountStyle() // call outro animation when mounted prop is false
    this.setState({ // remount the node when the mounted prop is true
      show: true
    })
    setTimeout(this.mountStyle, 10) // call the into animation
  }

  unMountStyle() { // css for unmount animation
    this.setState({
      style: {
        fontSize: 60,
        opacity: 0,
        transition: 'all 1s ease',
      }
    })
  }

  mountStyle() { // css for mount animation
    this.setState({
      style: {
        fontSize: 60,
        opacity: 1,
        left: "55px",
        transition: 'left 0.7s ease, opacity 0.5s ease',
      }
    })
  }

  componentDidMount(){
    setTimeout(this.mountStyle, 10) // call the into animation
  }

  transitionEnd(){
    /*
    if(!this.props.mounted){ // remove the node on transition end when the mounted prop is false
      this.setState({
        show: false
      })
    }
    */
  }

/*<h1 style={this.state.style} onTransitionEnd={this.transitionEnd}>Hello</h1> */

  render () {
    return (this.state.show &&
        <div className="scrolling-wrapper-flexbox" style={this.state.style} >
        {
          this.props.bachansArray.map(item => {
            var bachan1;
            if (!item.content_pa) {
              bachan1 = {__html: '<div class="bachan">' + item.content_en +
                '</div><div class="sggs">' + "-" + item.name_en + '</div>' }
            }
            else {
              bachan1 = {__html: '<div class="bachan">' + item.content_pa+'</div> \
                <div class="sggs">' + "-" + item.name_pa+'</div>' }
            };
            return (
            <div key={item.id} className="card-bachan" onClick={() => this.handleClick(item)} >
              <div className="bachan-preview"  dangerouslySetInnerHTML={bachan1}>
              </div>
              <div className="sggs">{item.name_pa}</div>
            </div> )
          })
        }
        </div>
      )
  }

}
